import {
  type AdminMinuteProgramEnrollmentsListParams,
  getAdminMinuteProgramEnrollmentsListQueryOptions,
} from "@sidegigllc/api/client";
import { marketsQueryOptions } from "api/queries/markets";
import { PARTICIPANT_STATES } from "domains/admin/components/TaskOpsParticipantsTable/helpers";
import type { WarmableQuery } from "routing/warmQueries";

type ParticipantsSearch = {
  page: number;
  page_size: number;
  search?: string;
  market?: number;
  state?: Array<(typeof PARTICIPANT_STATES)[number]>;
};

type QueriesInput = { search: ParticipantsSearch };

export const enrollmentsQuery = ({ search }: QueriesInput) => {
  const params: AdminMinuteProgramEnrollmentsListParams = {
    page: search.page,
    page_size: search.page_size,
    search: search.search,
    market: search.market,
    // The tab asks for pros currently in the programme. The Status dropdown can
    // only narrow within that, so a selection replaces the pair rather than
    // adding to it. Server-side either way: `count` and page slicing are SQL,
    // so narrowing after the fetch would describe rows the admin can't see.
    state: search.state?.length ? search.state : [...PARTICIPANT_STATES],
  };
  return getAdminMinuteProgramEnrollmentsListQueryOptions(params);
};

export const queries = (input: QueriesInput): Array<WarmableQuery> => [marketsQueryOptions(), enrollmentsQuery(input)];
